<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：服务信息
  -->
  <div class="pb50">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">服务信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col>
            <div class="pb16">
              <span class="gray9">用户ID：</span>
              {{ detail.user ? detail.user.user_id : detail.user_id }}
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">出发地址：</span>
              {{ detail.order_master ? detail.order_master.waiter_location : '' }}
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">到达地址：</span>
              {{ detail.order_master ? detail.order_master.user_location : '' }}
            </div>
          </el-col>
        </el-row>

      </div>

    </div>

  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  props: ["detail"],
  data() {
    return {
      // 技师是否显示
      isModify: false,
      active: 0,
      /*是否加载完成*/
      loading: true,
      /*订单数据*/
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*发货*/
      form: {
        /*订单ID*/
        express_id: null,
        /*订单号*/
        express_no: ""
      },
      forms: {
        is_cancel: 1
      },
      extract_form: {
        order: {
          extract_status: 1
        }
      },
      order: {},
      delivery_type: 0,
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*当前编辑的对象*/
      userModel: {},
      /*时间*/
      createTime: "",
      /*快递公司列表*/
      expressList: [],
      shopClerkList: [],
      /*是否打开编辑弹窗*/
      open_edit: false,
      isChange: false,
      addressData: {
        name: "",
        phone: "",
        province_id: 0,
        city: "",
        city_id: 0,
        region: "",
        region_id: 0,
        region: {
          province: "",
          province_id: 0,
          city: "",
          city_id: 0,
          region: "",
          region_id: 0,
          detail: "",
          username: ""
        }
      }
    };
  },
  created(e) {
    // console.log(e, "user_id");
    /*获取列表*/
    // this.getParams();
  },
  methods: {
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.orderId;
      OrderApi.orderdetail(
        {
          orderId: params
        },
        true
      )
        .then(data => {
          console.log(data);
          self.loading = false;
          self.detail = data.data.detail;
          self.expressList = data.data.expressList;
          self.shopClerkList = data.data.shopClerkList;
          self.addressData = self.detail.address;
          // self.username = self.detail.username
          self.user_id = self.detail.waiter_user_id;
          self.uses = self.detail.username;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        this.getParams();
      }
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    changeAdd() {
      this.isChange = true;
    },
    closeAddress(e) {
      let self = this;
      if (e == false) {
        self.isChange = false;
        console.log(e);
        return false;
      }
      let params = e.params;
      console.log(params);
      params.orderId = self.$route.query.orderId;
      OrderApi.updateAddress(params, true)
        .then(data => {
          self.$message({
            message: "修改成功",
            type: "success"
          });
        })
        .catch(error => { });
      self.isChange = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.img {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/refund/part/service.vue